var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import classNames from 'classnames';
import { uniqBy } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ELSInlineLoader } from '@els/els-ui-common-react';
import { ELSTab, ELSTabGroup } from 'components/common';
import AppFooter from 'components/common/app-footer/AppFooter';
import { Breadcrumb, BreadcrumbItem } from 'components/common/breadcrumb';
import PageHeader from 'reports/cw/components/common/cw-page-header/CWPageHeader';
import FlagCondition from 'components/common/flag-condition/FlagCondition';
import PageWrapper from 'components/common/page-wrapper/PageWrapper';
import withAppLinkingBackToPreviousApp from 'components/common/with-app-linking-back-to-previous-app/withAppLinkingBackToPreviousApp';
import withResizeScreen from 'components/common/with-resize-screen/withResizeScreen';
import { ANALYTIC_FEATURES, FeatureFlagNames, REPORT_TITLE, RoutePath } from 'constants/app.constant';
import { APP_LINK_PAGE_NAME_WITH_ROUTE } from 'constants/externalApp.constant';
import { renderNoDataFound } from 'helpers/ui.helper';
import { appSelectors } from 'redux/ducks/app';
import { filterActions, filterSelectors } from 'redux/ducks/filter';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import { ALL_EAQ_ASSIGNMENT_TYPE, ASSIGNMENT_TYPE_GROUPS, ASSIGNMENT_TYPES, getAssignmentTypeById } from 'reports/cw/constants/report.constant';
import useEAQStandaloneCourse from 'reports/cw/hooks/shared/useEAQStandaloneCourse';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { cwActions, cwSelectors } from 'reports/cw/redux/ducks/cw';
import { trackAAFeature } from 'services/adobe-analytics.service';
import { renderCourseNameBreadcrumb } from 'services/app-linking.service';
import { isFeatureEnabled } from 'services/feature-flag.service';
import CWCoursePickerButton from '../../common/cw-course-picker-button/CWCoursePickerButton';
import AssignmentEngagement from '../assignment-engagement/AssignmentEngagement';
import StudentEngagement from '../student-engagement/StudentEngagement';
import EngagementHeader from './engagement-header/EngagementHeader';
import EngagementTable from './engagement-table/EngagementTable';
require('reports/cw/assets/images/icon-sprite_icon__insert-question.svg');
require('reports/cw/assets/images/icon-sprite_icon__eaq.svg');
require('reports/cw/assets/images/icon-sprite_icon__lightbulb.svg');
export var ENGAGEMENT_TABS = {
    student: {
        name: 'Student Engagement',
        index: 0
    },
    assignment: {
        name: 'Assignment Engagement',
        index: 1
    }
};
export var getFilteredAssignmentEngagement = function (assignmentEngagement, assignmentType) {
    if (assignmentType === ALL_EAQ_ASSIGNMENT_TYPE.id) {
        return assignmentEngagement.filter(function (ae) { var _a; return ((_a = ASSIGNMENT_TYPES[ae.assignmentType]) === null || _a === void 0 ? void 0 : _a.group) === ASSIGNMENT_TYPE_GROUPS.EAQ; });
    }
    if (assignmentType === ASSIGNMENT_TYPES.LESSONS.id) {
        return assignmentEngagement.filter(function (ae) { return ae.assignmentType === ASSIGNMENT_TYPES.LESSONS.id || ae.assignmentType === ASSIGNMENT_TYPES.ADAPTIVE_LESSON.id; });
    }
    return assignmentEngagement.filter(function (ae) { return ae.assignmentType === assignmentType; });
};
export var getAssignmentTypeOptions = function (listContentTypeAvailable, isEAQStandaloneCourse) {
    if (isEAQStandaloneCourse === void 0) { isEAQStandaloneCourse = false; }
    var assignmentTypeOptions = [];
    Object.values(ASSIGNMENT_TYPES).forEach(function (assignmentType) {
        if (listContentTypeAvailable.includes(assignmentType.id)) {
            var id = assignmentType.id, name = assignmentType.name, icon = assignmentType.icon;
            assignmentTypeOptions = uniqBy(__spreadArray(__spreadArray([], assignmentTypeOptions, true), [
                {
                    key: id,
                    name: name,
                    icon: icon
                }
            ], false), 'name');
        }
    });
    var hasEaqTypeAvailable = assignmentTypeOptions.some(function (option) { var _a; return ((_a = ASSIGNMENT_TYPES[option.key]) === null || _a === void 0 ? void 0 : _a.group) === ASSIGNMENT_TYPE_GROUPS.EAQ; });
    if (isEAQStandaloneCourse && hasEaqTypeAvailable) {
        var id = ALL_EAQ_ASSIGNMENT_TYPE.id, name = ALL_EAQ_ASSIGNMENT_TYPE.name, icon = ALL_EAQ_ASSIGNMENT_TYPE.icon;
        return __spreadArray([{ key: id, name: name, icon: icon }], assignmentTypeOptions, true);
    }
    return assignmentTypeOptions;
};
var Engagement = function (_a) {
    var _b;
    var assignmentTypeId = _a.assignmentTypeId, courseSectionInfo = _a.courseSectionInfo, isAssignmentEngagementReportLoading = _a.isAssignmentEngagementReportLoading, isStudentEngagementReportLoading = _a.isStudentEngagementReportLoading, courseId = _a.courseId, assignmentEngagement = _a.assignmentEngagement, assignmentTypeOptions = _a.assignmentTypeOptions, fetchAssignmentEngagementReport = _a.fetchAssignmentEngagementReport, fetchStudentEngagementReport = _a.fetchStudentEngagementReport, setAssignmentTypeId = _a.setAssignmentTypeId, xLinkId = _a.xLinkId, handleBackPreviousAppIconClick = _a.handleBackPreviousAppIconClick, isBackToPreviousAppIconShown = _a.isBackToPreviousAppIconShown, windowMode = _a.windowMode, featureFlags = _a.featureFlags;
    var location = useLocation();
    var history = useHistory();
    var _c = useState(0), activeTabIndex = _c[0], setActiveTabIndex = _c[1];
    var _d = useState([]), filteredAssignmentEngagement = _d[0], setFilteredAssignmentEngagement = _d[1];
    var isGradePointsEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_GRADE_WEIGHTING_SCORE_ENABLED);
    var isCwUpdatedUiEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_UPDATED_UI_ENABLED);
    var engagementLandingPath = useEAQStandaloneCourse().engagementLandingPath;
    var changeTab = useCallback(function (index) {
        var studentIdx = ENGAGEMENT_TABS.student.index;
        setActiveTabIndex(index);
        if (index === studentIdx) {
            trackAAFeature(ANALYTIC_FEATURES.CW_ENGAGEMENT_STUDENT_TAB_VIEW);
            history.push(PerformancePath.engagement.student);
        }
        else {
            trackAAFeature(ANALYTIC_FEATURES.CW_ENGAGEMENT_ASSIGNMENT_TAB_VIEW);
            history.push(PerformancePath.engagement.assignment);
        }
    }, [history]);
    var setInitialTab = useCallback(function () {
        if (location.pathname === PerformancePath.engagement.student) {
            setActiveTabIndex(ENGAGEMENT_TABS.student.index);
        }
        else {
            setActiveTabIndex(ENGAGEMENT_TABS.assignment.index);
        }
    }, [location.pathname]);
    useEffect(function () {
        if (assignmentTypeId) {
            fetchStudentEngagementReport(courseId, assignmentTypeId);
        }
    }, [assignmentTypeId, courseId, fetchStudentEngagementReport]);
    // TODO: When new home page ticket is done
    //  ---> Move call API AssignmentEngagement into new Home Page to use this data in Home Page, Assignment Engagement, and Assignment Summary
    useEffect(function () {
        if (!(courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.id)) {
            return;
        }
        fetchAssignmentEngagementReport(courseId, assignmentTypeId);
    }, [assignmentTypeId, courseId, courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.id, fetchAssignmentEngagementReport]);
    useEffect(function () {
        setInitialTab();
    }, [isAssignmentEngagementReportLoading, isStudentEngagementReportLoading, setInitialTab]);
    useEffect(function () {
        setFilteredAssignmentEngagement(getFilteredAssignmentEngagement((assignmentEngagement === null || assignmentEngagement === void 0 ? void 0 : assignmentEngagement.metrics) || [], assignmentTypeId));
    }, [assignmentTypeId, assignmentEngagement]);
    var currentAppLinkPage = activeTabIndex === ENGAGEMENT_TABS.assignment.index ? APP_LINK_PAGE_NAME_WITH_ROUTE.CW_ASSIGNMENT_ENGAGEMENT.name : APP_LINK_PAGE_NAME_WITH_ROUTE.CW_STUDENT_ENGAGEMENT.name;
    var buildContent = function () {
        if ((assignmentTypeOptions === null || assignmentTypeOptions === void 0 ? void 0 : assignmentTypeOptions.length) && assignmentTypeId) {
            return (<div className="c-cw-engagement__content">
          <div className={classNames('c-cw-engagement__content-header-wrapper', { 'u-els-background-color-n0': !isCwUpdatedUiEnabled })}>
            <div className="u-max-width-1400 u-els-padding-2x u-els-padding-bottom u-els-padding-left@mobile u-els-padding-right@mobile u-els-width-1o1 c-cw-report-content">
              <EngagementHeader filteredAssignmentEngagement={filteredAssignmentEngagement} assignmentTypeOptions={assignmentTypeOptions} assignmentTypeValue={assignmentTypeId} onSetAssignmentTypeValue={setAssignmentTypeId} trackAAFeature={trackAAFeature} onChangeTab={changeTab}/>
            </div>
          </div>

          <div className="u-max-width-1400 u-els-padding-1x1o2 u-els-padding-none@mobile u-els-width-1o1 c-cw-report-content">
            <FlagCondition featureFlagName={FeatureFlagNames.CW_UPDATED_UI_ENABLED} trueStatement={isStudentEngagementReportLoading ? (<ELSInlineLoader />) : (<EngagementTable assignmentTypeId={assignmentTypeId} filteredAssignmentEngagement={filteredAssignmentEngagement}/>)} falseStatement={<>
                  <ELSTabGroup navWrapperCssClasses={['u-els-margin-left-1o2', 'u-els-margin-left@mobile', 'c-els-divider c-els-divider--1o2']} activeIndex={activeTabIndex} onChangeActiveIndex={changeTab} hasDivider={false}>
                    <ELSTab title={ENGAGEMENT_TABS.student.name}>
                      {isStudentEngagementReportLoading ? (<ELSInlineLoader />) : (<StudentEngagement assignmentTypeId={assignmentTypeId} filteredAssignmentEngagement={filteredAssignmentEngagement} isGradePointsHidden={!isGradePointsEnabled}/>)}
                    </ELSTab>
                    <ELSTab title={ENGAGEMENT_TABS.assignment.name}>
                      <AssignmentEngagement assignmentTypeId={assignmentTypeId} filteredAssignmentEngagement={filteredAssignmentEngagement}/>
                    </ELSTab>
                  </ELSTabGroup>
                  <div className="c-els-divider c-els-divider--1o2"/>
                </>}/>
          </div>
        </div>);
        }
        return renderNoDataFound();
    };
    return (<PageWrapper>
      <PageHeader showNavigation title={REPORT_TITLE.SHERPATH_PERFORMANCE_GRADES.defaultTitle} componentBelowHeader={<CWCoursePickerButton courseSectionInfo={courseSectionInfo}/>} currentAppLinkPage={currentAppLinkPage}>
        <Breadcrumb>
          {courseSectionInfo ? renderCourseNameBreadcrumb(courseSectionInfo.courseName, xLinkId, isBackToPreviousAppIconShown, handleBackPreviousAppIconClick) : ''}
          {!windowMode.mobile && (<BreadcrumbItem>
              <Link to={RoutePath.cwIns}>Performance</Link>
            </BreadcrumbItem>)}
          <BreadcrumbItem>
            <Link to={engagementLandingPath}>Engagement</Link>
          </BreadcrumbItem>
          {assignmentTypeId && !windowMode.mobile && <BreadcrumbItem>{(_b = getAssignmentTypeById(assignmentTypeId)) === null || _b === void 0 ? void 0 : _b.name}</BreadcrumbItem>}
        </Breadcrumb>
      </PageHeader>
      <div className="c-cw-engagement">
        {isAssignmentEngagementReportLoading ? (<div className="c-cw-engagement__loader">
            <ELSInlineLoader />
          </div>) : (buildContent())}
      </div>
      <AppFooter />
    </PageWrapper>);
};
var mapStateToProps = function (state) { return ({
    courseSectionInfo: courseSelectors.getCourseSectionInfo(state),
    courseId: appSelectors.getSelectedCourse(state),
    assignmentEngagement: cwSelectors.getAssignmentEngagement(state),
    assignmentTypeOptions: cwSelectors.getAssignmentTypeOptions(state),
    isStudentEngagementReportLoading: cwSelectors.getStudentEngagementReportLoading(state),
    isAssignmentEngagementReportLoading: cwSelectors.getAssignmentEngagementReportLoading(state),
    reportLoading: cwSelectors.getReportLoading(state),
    assignmentTypeId: filterSelectors.getCWEngagementAssignmentTypeDropdownId(state),
    redirectUrl: appSelectors.getRedirectUrl(state),
    featureFlags: appSelectors.getFeatureFlags(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    fetchAssignmentEngagementReport: function (courseId, assignmentType) { return dispatch(cwActions.fetchAssignmentEngagementReport(courseId, assignmentType)); },
    fetchStudentEngagementReport: function (courseId, assignmentType) { return dispatch(cwActions.fetchStudentEngagementReport(courseId, assignmentType)); },
    setAssignmentTypeId: function (id) { return dispatch(filterActions.setCWEngagementAssignmentTypeDropdownId(id)); }
}); };
export { Engagement as EngagementBase };
export default connect(mapStateToProps, mapDispatchToProps)(withAppLinkingBackToPreviousApp(withResizeScreen(Engagement)));
